(function() {
    'use strict';

    angular
        .module('eDocumentsApp')
        .constant('paginationConstants', {
            'itemsPerPage': 20
        });
})();
